import { Link } from '@tanstack/react-router';

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

interface BrandBarProps {
  logoUrl?: string;
  studioName: string;
}

export const BrandBar = ({ logoUrl, studioName }: BrandBarProps) => {
  return (
    <Card className='rounded-xl border border-[#E5E7EB] bg-white p-6 shadow-sm transition hover:shadow-md'>
      <CardHeader className='p-0 pb-4'>
        <CardTitle className='text-sm font-medium'>Brand & Logo</CardTitle>
      </CardHeader>
      <CardContent className='space-y-4 p-0'>
        <div className='flex items-center justify-center rounded-lg border-2 border-dashed bg-gray-50 py-8 transition hover:bg-[#FFF9E6]'>
          {logoUrl ? (
            <img
              src={logoUrl}
              alt='Email logo'
              className='max-h-12 object-contain'
              style={{ maxHeight: '48px' }}
            />
          ) : (
            <span className='text-lg font-semibold tracking-tight text-[#000814]'>
              {studioName}
            </span>
          )}
        </div>
        <p className='text-xs text-muted-foreground'>
          This is the logo families see at the top of welcome emails. Update it
          in{' '}
          <Link
            to='/studio-profile'
            className='font-medium text-foreground underline underline-offset-2'
          >
            Studio Profile
          </Link>
          .
        </p>
      </CardContent>
    </Card>
  );
};
